import React from "react";
import "./GroupStrengthBlock.css";

function GroupStrengthBlock({ title, intro, sisterCompany, regions, stats, footer }) {
  return (
    <section className="block block13">

      <h2 className="block13-title">{title || ''}</h2>

      <p className="block13-intro">
        {intro || ''}
        {sisterCompany && <strong> {sisterCompany}</strong>}
      </p>

      <div className="block13-countries">
        {(regions || []).map((region, index) => (
          <div key={index}>{region}</div>
        ))}
      </div>

      {stats && (
        <div className="block13-stats">
          <div className="stat">
            <h1>{stats.completed || ''}</h1>
            <p>{stats.completedLabel || ''}</p>
          </div>
          <div className="stat">
            <h1>{stats.underExecution || ''}</h1>
            <p>{stats.underExecutionLabel || ''}</p>
          </div>
        </div>
      )}

      <p className="block13-footer">{footer || ''}</p>

    </section>
  );
}

export default GroupStrengthBlock;
